module.exports = __webpack_public_path__ + "img/star-gray-icon.94b05fa6.svg";